import { Injectable } from '@angular/core';
import { SortType, SortDirection } from '../constants-types/Enums';
import { SortInfo } from '../core-data-model/SortInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue,
    UnknownFilterTypeError
} from '../core-services/ODataQueryGenerator.service';

@Injectable({ providedIn: 'root' })
export class BehavioralAssessmentsQueryGeneratorService extends ODataQueryGeneratorService {
    getOrderbyParameter(sortingState: SortInfo[]): KeyValue[] {
        const sortList = sortingState.map((sortInfo: SortInfo) => {
            let oDataSort;
            const oDataDirection =
                sortInfo.direction === SortDirection.Ascending ? 'asc' : 'desc';
            switch (sortInfo.sortType) {
                case SortType.RecentlySent:
                    oDataSort = 'assessmentDateTime';
                    break;
                case SortType.RecentlyCompleted:
                    oDataSort = 'assessmentCompletedDateTime';
                    break;
                default:
                    throw new UnknownFilterTypeError();
            }
            return `${oDataSort} ${oDataDirection}`;
        });
        if (sortList.length > 0) {
            return [
                {
                    key: '$orderby',
                    value: sortList.join(',')
                }
            ];
        }
        return [];
    }
}
